import Marquee from "react-fast-marquee";
import { useLang } from "../../contexts/LanguageContext";

export default function MembersMarquee({ logos }) {
  const { t } = useLang();
  if (!logos || logos.length === 0) return null;

  return (
    <section className="bg-white py-20 border-y border-gray-100" data-testid="members-marquee">
      <div className="max-w-7xl mx-auto px-6 mb-10 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#C8102E] mb-3">
          {t("home.partnersTitle")}
        </p>
        <h2 className="font-serif text-3xl md:text-4xl text-[#0F2040]">{t("home.partnersSubtitle")}</h2>
      </div>
      <div className="marquee-fade">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {logos.map((l) => {
            const img = (
              <img
                src={l.image_url}
                alt={l.alt || l.name}
                title={l.title || l.name}
                loading="lazy"
                className="h-16 md:h-20 w-auto object-contain opacity-70 hover:opacity-100 grayscale hover:grayscale-0 transition-all duration-500"
              />
            );
            return (
              <div key={l.id} className="mx-10 md:mx-14 flex items-center" data-testid={`marquee-logo-${l.id}`}>
                {l.url ? (
                  <a href={l.url} target="_blank" rel="noreferrer" title={l.title || l.name}>
                    {img}
                  </a>
                ) : (
                  img
                )}
              </div>
            );
          })}
        </Marquee>
      </div>
    </section>
  );
}
